import { create } from "zustand";
import { IUser } from "../@core/interfaces/IUser";

interface StoreState {
  user: IUser | null;
  setUser: (user: IUser | null) => void;
  loading: boolean;
}

export const useUserSessionStore = create<StoreState>((set) => ({
  user: null,
  loading: true,
  setUser: (user: IUser | null) => set(() => ({ user, loading: false }))
}));
